import { ActivityMetadataModel } from '../../../../api/api';
import useFlowMetadata from './useFlowMetadata';

export default function useFlowActivityMetadata(name: string): ActivityMetadataModel | undefined {
	const { activityByName } = useFlowMetadata();
	return activityByName.get(name);
}
